export default {"src":"/_next/static/media/ico_add-cart-light.f386b9ac.svg","height":50,"width":51};